'use strict';

var defineProperty = require('../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var Grid = require('../DesignSystem/Layout/Grid/Grid.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function GridWithSpacing(_ref) {
  var children = _ref.children,
      spacing = _ref.spacing,
      rest = objectWithoutProperties(_ref, ["children", "spacing"]);

  return React__default["default"].createElement("div", {
    style: {
      padding: spacing / 2
    }
  }, React__default["default"].createElement(Grid, _objectSpread({
    container: true,
    spacing: spacing
  }, rest), children));
}

module.exports = GridWithSpacing;
